// extracted by mini-css-extract-plugin
export var link = "gamification-introduction-module--link--BEBlC";
export var linksWrapper = "gamification-introduction-module--links-wrapper--eKs7R";